import { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useAsync } from 'react-async-hook'
import Box from '@mui/material/Box'

import { getTotalOutputCount } from '../../../redux/actions/outputsActions'
import Pendable from '../../common/Pendable'
import { Link } from '../../common/Link'
import NumericalDataSet from '../../common/NumericalDataSet'
import { DEFAULT_PAGINATION, useApplianceSelector, useInputsSelector } from '../../../utils'
import { Api, AppDispatch, GlobalState, useRoutes } from '../../../store'
import { getUsers } from '../../../redux/actions/userActions'

const { userApi } = Api
const trackEvent = { component: 'Availability' }

const Availability = () => {
  const dispatch = useDispatch<AppDispatch>()
  useEffect(() => {
    dispatch(getTotalOutputCount())
  }, [dispatch])
  const { total: outputsTotal, loading: outputsLoading } = useSelector(
    ({ outputsReducer }: GlobalState) => ({ total: outputsReducer.total, loading: outputsReducer.loading }),
    shallowEqual,
  )
  const { loading: inputsLoading, total: inputsTotal } = useInputsSelector(DEFAULT_PAGINATION)
  const { loading: appliancesLoading, total: appliancesTotal, totalRegions } = useApplianceSelector(DEFAULT_PAGINATION)

  const users = useAsync(() => getUsers(DEFAULT_PAGINATION, { dispatch, userApi }), [])

  const routes = useRoutes()
  const isPending = users.loading || appliancesLoading || inputsLoading || outputsLoading
  return (
    <Pendable pending={isPending}>
      <Box sx={{ width: '100%' }}>
        <NumericalDataSet
          values={[
            {
              title: (
                <Link to={routes.inputs()} underline="hover" trackEvent={trackEvent}>
                  Inputs available
                </Link>
              ),
              value: inputsTotal,
            },
            {
              title: (
                <Link to={routes.outputs()} underline="hover" trackEvent={trackEvent}>
                  Outputs available
                </Link>
              ),
              value: outputsTotal,
            },
            {
              title: (
                <Link to={routes.users()} underline="hover" trackEvent={trackEvent}>
                  User accounts
                </Link>
              ),
              value: users.result?.total,
            },
            {
              title: (
                <Link to={routes.appliances()} underline="hover" trackEvent={trackEvent}>
                  Appliances
                </Link>
              ),
              value: appliancesTotal,
            },
            {
              title: (
                <Link to={routes.regions()} underline="hover" trackEvent={trackEvent}>
                  Regions
                </Link>
              ),
              value: totalRegions,
            },
          ]}
        />
      </Box>
    </Pendable>
  )
}

export default Availability
